/* tslint:disable */
import {
  Player,
  Prize,
  Game,
  Inquiry
} from '../index';

declare var Object: any;
export interface PlayerPrizeInterface {
  "id"?: any;
  "playerId"?: any;
  "prizeId"?: any;
  "gameId"?: any;
  "createdAt": Date;
  "updatedAt": Date;
  player?: Player;
  prize?: Prize;
  game?: Game;
  inquiry?: Inquiry[];
}

export class PlayerPrize implements PlayerPrizeInterface {
  "id": any;
  "playerId": any;
  "prizeId": any;
  "gameId": any;
  "createdAt": Date;
  "updatedAt": Date;
  player: Player;
  prize: Prize;
  game: Game;
  inquiry: Inquiry[];
  constructor(data?: PlayerPrizeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PlayerPrize`.
   */
  public static getModelName() {
    return "PlayerPrize";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PlayerPrize for dynamic purposes.
  **/
  public static factory(data: PlayerPrizeInterface): PlayerPrize{
    return new PlayerPrize(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PlayerPrize',
      plural: 'player-prizes',
      path: 'player-prizes',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'any'
        },
        "playerId": {
          name: 'playerId',
          type: 'any'
        },
        "prizeId": {
          name: 'prizeId',
          type: 'any'
        },
        "gameId": {
          name: 'gameId',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        player: {
          name: 'player',
          type: 'Player',
          model: 'Player',
          relationType: 'belongsTo',
                  keyFrom: 'playerId',
          keyTo: 'id'
        },
        prize: {
          name: 'prize',
          type: 'Prize',
          model: 'Prize',
          relationType: 'belongsTo',
                  keyFrom: 'prizeId',
          keyTo: 'id'
        },
        game: {
          name: 'game',
          type: 'Game',
          model: 'Game',
          relationType: 'belongsTo',
                  keyFrom: 'gameId',
          keyTo: 'id'
        },
        inquiry: {
          name: 'inquiry',
          type: 'Inquiry[]',
          model: 'Inquiry',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'playerPrizeId'
        },
      }
    }
  }
}
